import {defineStore} from 'pinia'
import api from '@/services/api'
import {useUserStore} from '@/stores/user'

export const useUserTrackingStore = defineStore('userTracking', {
    state: () => ({
        promises: {},
        data: {},
    }),
    
    getters: {
        _getKey: () => (componentId, itemId) => {
            return `${componentId}:${itemId}`
        },
    },
    
    actions: {
        async init() {
            await this._setData()
            
            setInterval(async () => {
                await this._setData()
            }, 1000)
        },
        
        start({componentId, itemId}) {
            if (itemId === 0) {
                return
            }
            
            this.stop({componentId, itemId})
            
            const key = this._getKey(componentId, itemId)
            const userStore = useUserStore()
            
            const intervalId = setInterval(async () => {
                const userId = userStore.user?.id
                if (userId) {
                    await api.post('api/user-tracking', {
                        userId,
                        componentId,
                        itemId,
                    })
                }
            }, 1000)
            
            this.promises[key] = intervalId
        },
        
        async stop({componentId, itemId}) {
            const key = this._getKey(componentId, itemId)
            
            if (this.promises[key]) {
                clearInterval(this.promises[key])
                delete this.promises[key]
                
                await api.delete(`api/user-tracking/${key}`)
            }
        },
        
        async inUse({componentId, itemId}) {
            await this._setData()
            return this.checkKeys({componentId, itemId})
        },
        
        checkKeys({componentId, itemId}) {
            const key = this._getKey(componentId, itemId)
            return key in this.data ? this.data[key] : false
        },
        
        async _setData() {
            const userStore = useUserStore()
            const userId = userStore.user?.id
            
            if (userId) {
                const response = await api.get('api/user-tracking', {
                    params: {userId},
                })
                
                const items = response.data?.items || []
                
                items.forEach((item) => {
                    const key = `${item.componentId}:${item.itemId}`
                    this.data[key] = item.userId
                })
            }
        },
    },
})